export default __webpack_public_path__ + "static/media/photo.39121709.svg";